export const COMMUNITY_POST_AUTHOR_TYPE = {
  MORFY_TEAM: "MORFY_TEAM",
  USER: "USER",
};

export const COMMUNITY_POST_AUTHOR_CHOICES = [
  { id: COMMUNITY_POST_AUTHOR_TYPE.MORFY_TEAM, name: "Morfy" },
  { id: COMMUNITY_POST_AUTHOR_TYPE.USER, name: "Usuario" },
];
